import React from 'react';
import cn from 'classnames';
import DumbView from '../../../DeviationViews/Dumbo/EditorDumbo';
import PriceWithPoints from '../../../ShopCard/_partials/PriceWithPoints';
import { getDeviationPrice } from '../../../utils/deviations';
import { formatDollars } from '../../../utils/formatting';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './Commission.scss';
const CommissionInlineView = (props)=>{
    const { deviation, width, height } = props;
    const { dollarsPrice, pointsPrice } = getDeviationPrice(deviation);
    const { title, author } = deviation;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root']),
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement(DumbView, {
        className: s['thumb'],
        width: width - 2,
        height: height,
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        className: s['details']
    }, /*#__PURE__*/ React.createElement(Flex, {
        direction: "row",
        alignItems: "stretch"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-cell']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['avatar']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: author,
        size: 28
    }))), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['two-center-cells'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), author && /*#__PURE__*/ React.createElement("div", {
        className: s['username']
    }, /*#__PURE__*/ React.createElement(UserLink, {
        user: author
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-cell']
    }, /*#__PURE__*/ React.createElement(PriceWithPoints, {
        formattedDollarsPrice: formatDollars(dollarsPrice),
        pointsPrice: pointsPrice
    }))))));
};
CommissionInlineView.displayName = 'CommissionInlineView';
export default CommissionInlineView;

//# sourceMappingURL=Commission.js.map